module.exports = __webpack_public_path__ + "img/file-x-02.c51c21ad.svg";